import { useState, useEffect } from "preact/hooks";
import classNames from "../../../bpmn.io/classnames";
import { Select } from "../../../bpmn.io/@bpmn-io/form-js";
import { AppData } from "../../helpers/app-data";
import{ html } from 'htm/preact';

export const type = "selectUsuarios";

export function formFieldClasses(
  type,
  { errors = [], disabled = false, readonly = false } = {}
) {
  if (!type) {
    throw new Error("type required");
  }

  return classNames("fjs-form-field", `fjs-form-field-${type}`, {
    "fjs-has-errors": errors.length > 0,
    "fjs-disabled": disabled,
    "fjs-readonly": readonly,
  });
}

export function SelectComponent(props) {
  const {
    disabled,
    errors = [],
    domId,
    onBlur,
    onFocus,
    field,
    onChange,
    readonly,
    value,
  } = props;

  const { description, label, searchable = false, validate = {} } = field;

  const { required } = validate;

  const descriptionId = `${domId}-description`;
  const errorMessageId = `${domId}-error-message`;

  const selectProps = {
    domId,
    disabled,
    errors,
    onBlur,
    onFocus,
    field,
    value,
    onChange,
    readonly,
    required,
    "aria-invalid": errors.length > 0,
    "aria-describedby": [descriptionId, errorMessageId].join(" "),
  };

  const [isButtonVisible, setIsButtonVisible] = useState(true); // Estado para controlar la visibilidad del select
  const [options, setOptions] = useState([]); // Estado para almacenar los datos obtenidos

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    /* const selectedOption = options.find(
      (option) => option.Id === selectedValue
    ); */
    
    
    onChange({ value: selectedValue, field }); // Actualizar el valor seleccionado en el formulario
  };

  useEffect(() => {
    const baseService = window.baseService;
    if (baseService) {
      const subscription = baseService.currentTablaArchivosVisible.subscribe(
        (isVisible) => {
          if (!isVisible) {
            setIsButtonVisible(isVisible);
          }
        }
      );
      return () => subscription.unsubscribe();
    }
  }, []);

  useEffect(() => {
    if (isButtonVisible) {
      fetchData();
    }
  }, [isButtonVisible]);

  const fetchData = () => {
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);
    if (!API_TOKEN) {
      console.error("API token not found");
      return;
    }

    const url = `${AppData.API_URL}Usuario/ListaUsuario`;
    const headers = {
      "Content-Type": "application/json",
      "X-APIKey": AppData.API_KEY,
      Authorization: `Bearer ${API_TOKEN}`,
    };

    fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((responseData) => {
        setOptions(responseData.Data || []);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  if (!isButtonVisible) {
    return html`
      <div class=${formFieldClasses(type, { disabled })}>
        <label>${label}</label>
        <select
          disabled
          class=${classNames("fjs-select", { disabled, readonly })}
        >
        <option selected >Usuarios...</option>
        </select>
      </div>
    `;
  } else {
    return html`
      <div class=${formFieldClasses(type, { disabled })}>
        <label>${label}</label>
        <select class=${classNames("fjs-select", { disabled, readonly })}
        onChange=${handleSelectChange}
        >
          ${options.map(
            (option) => html`
              <option value=${option.Id}>${option.NombreUsuario}</option>
            `
          )}
        </select>
      </div>
    `;
  }
}

SelectComponent.config = {
  ...Select.config,
  type: type,
  label: "Lista Usuarios",
};
